<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des traitements</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="action" slot-scope="props">
            <b-button
              type="button"
              @click.prevent="destroy(props.row.id)"
              class="badge badge-danger mr-3 p-2">
              <i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button
              type="button"
              @click="voirTraitement('edit', props.row.id)"
              class="badge badge-primary p-2">
              <i class="fa fa-eye"></i> Voir
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button
          type="button"
          @click="voirTraitement('add')"
          class="pull-right"
          size="md"
          variant="primary">
          <i class="fa fa-plus"></i> Ajouter un traitement
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    data() {
      return {
        columns: ["libelle","libelle_court","libelle_technique", "categorie", "ordre", "type", 'status_retour.libelle_bo', "action"],
        items: [],
        options: {
          headings: {
            libelle: "Libellé",
            libelle_court: "Libellé court",
            libelle_technique: "Libellé technique",
            categorie: "Catégorie",
            ordre: "Ordre",
            type: "Type",
            'status_retour.libelle_bo': 'Statut de retour',
          },
          sortable: ["ordre", "libelle", "categorie", "type"],
          filterable: ["libelle", "categorie", "type"],
          perPage: 10,
          perPageValues: [10, 20, 25],
          texts: {filterPlaceholder: "Libellé, Catégorie, Type"},
          orderBy: {column: "libelle", ascending: false},
        },
      };
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.all();
    },
    methods: {
      all() {
        let self = this;
        this.$axios
          .get("/administration/traitements")
          .then(response => {
            this.items = response.data.traitements;
          })
          .catch(() => {
            self.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Un probléme est survenu, merci de contacter l'administrateur",
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      destroy(id) {
        this.$swal
          .fire({
            title: "Êtes-vous sûr?",
            text: "Voulez-vous vraiment supprimer ce traitement ?",
            type: "warning",
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: "Annuler",
            cancelButtonText: "Supprimer"
          })
          .then(result => {
            if (!result.value) {
              this.$store.commit("IS_LOADING", true);
              this.$axios
                .post("/administration/traitements/delete/" + id)
                .then(() => {
                  this.$store.commit("IS_LOADING", false);
                  this.$swal({
                    position: "top",
                    type: "success",
                    title: "Suppression avec succès",
                    text: "Le traitement a bien été supprimé",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  self.$store.commit("IS_LOADING", false);
                  self.$swal({
                    position: "top",
                    type: "warning",
                    title: "Attention !!",
                    text: "Un probléme est survenu, merci de contacter l'administrateur",
                    showConfirmButton: false,
                    timer: 5000
                  });
                });
            }
          });
      },
      voirTraitement(to, id) {
        if (to === "add") {
          this.$router.push({path: "/administration/traitements/add"});
        } else if (to === "edit") {
          this.$router.push({path: "/administration/traitements/edit/" + id});
        }
      },
      returnBack() {
        this.$router.push({path: "/administration/traitements"});
      },
    }
  };
</script>
